import { useCallback, useEffect, useState } from 'react'

import * as DialogPrimitive from '@radix-ui/react-dialog'

export type UseDialogProps = {
  isDefaultOpen?: boolean
  onOpen?: () => void
  onClose?: () => void
}

export type UseDialogReturn = {
  dialogProps: DialogPrimitive.DialogProps
  isOpen: boolean
  openDialog: () => void
  closeDialog: () => void
}

export const useDialog = ({
  isDefaultOpen = false,
  onOpen,
  onClose
}: UseDialogProps = {}): UseDialogReturn => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  useEffect(() => {
    setIsOpen(isDefaultOpen)
  }, [isDefaultOpen])

  const openDialog = useCallback(() => {
    setIsOpen(true)
    typeof onOpen === 'function' && onOpen()
  }, [onOpen])

  const closeDialog = useCallback(() => {
    setIsOpen(false)
    typeof onClose === 'function' && onClose()
  }, [onClose])

  const handleOpenChange = useCallback(
    (nextIsOpen) => {
      if (nextIsOpen) {
        openDialog()
      } else {
        closeDialog()
      }
    },
    [openDialog, closeDialog]
  )

  return {
    isOpen,
    openDialog,
    closeDialog,
    dialogProps: {
      open: isOpen,
      onOpenChange: handleOpenChange
    }
  }
}
